export class HeatmapSectionEnum {
  static None = 0;
  static Small = 81;
  static Large = 9;
}
